import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomers } from "./customerSlice";

const initialState = {
  currentPage: 1,
  rowsPerPage: 10,
  totalPages: 1,
};

const customerPaginationSlice = createSlice({
  name: "customerPagination",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomers.fulfilled, (state, action) => {
      state.totalPages = action.payload.totalPages;
    });
  },
});

export const { setCurrentPage, setRowsPerPage, setTotalPages } =
  customerPaginationSlice.actions;

export const selectCurrentPage = (state) =>
  state.customerPagination.currentPage;
export const selectTotalPages = (state) => state.customerPagination.totalPages;
export const selectRowsPerPage = (state) =>
  state.customerPagination.rowsPerPage;

export default customerPaginationSlice.reducer;
